import { useState } from 'react'
import Debug from 'debug'
import { observer } from 'mobx-react-lite'

import { PlainBrandIcon } from '@jotta/ui/BrandIcon'

import { SharePhotosDialog } from '../Album/Dialogs/SharePhotosDialog'

import type { PhotoActionHandlerActionProps } from './PhotoActionHandlers'
import { useDispatchPhotoActionMutation } from './useDispatchPhotoActionMutation'
const debug = Debug('jotta:photos:action:SharePhotos')

export const ActionSharePhotos = observer<
  PhotoActionHandlerActionProps<'SHARE_PHOTO'>
>(function ActionSharePhotos({
  action,
  photoIds = [],
  dispatch,
  mutationOptions,
  shareId: initialShareId,
  buttonClass,
  onActionDialogClose,
  disabled = false,
}) {
  const [shareId, setShareId] = useState(initialShareId)
  const [albumId, setAlbumId] = useState('')

  const shareMutation = useDispatchPhotoActionMutation(
    'SHARE_PHOTO',
    {
      ...mutationOptions,
      onSettled: async data => {
        const album = await data

        debug('onSettled', album)
        if (album) {
          const shareId = album.shareInfo && album.shareInfo.uri
          setShareId(shareId)
          setAlbumId(album.id)
        }
      },
    },
    dispatch,
  )
  const unshareMutation = useDispatchPhotoActionMutation(
    'UNSHARE_ALBUM',
    {
      onSuccess: async data => {
        await data
        setShareId('')
        return undefined
      },
    },
    dispatch,
  )

  return (
    <SharePhotosDialog
      photoCount={photoIds.length}
      shareId={shareId}
      onOpenChange={open => {
        if (!open && onActionDialogClose) {
          onActionDialogClose(action.actionType)
        }
      }}
      onSharePhoto={nextShareState => {
        if (!disabled) {
          if (!nextShareState && albumId) {
            unshareMutation.mutate([albumId])
          } else {
            shareMutation.mutate([photoIds])
          }
        }
      }}
      isLoading={shareMutation.isPending}
      triggerElement={
        <button
          type="button"
          aria-label={action.label}
          data-testid={action.testid}
          aria-busy={shareMutation.isPending}
          disabled={disabled}
          key={action.actionType}
          className={buttonClass}
        >
          <PlainBrandIcon icon={action.icon} />
          <span>{action.label}</span>
        </button>
      }
    />
  )
})
